import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl';
import utils from '@/shared/utils/adminpulse';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import Checkbox from '@/shared/components/input/Checkbox';
import messages from '../jobMessages';
import api from '@/shared/api';
import config from '@/config';
import CurrencySymbol from '@/shared/components/CurrencySymbol';

const JobDetailPriceGridUpdate = ({ job, intl }) => {
  const [gridName, setGridName] = useState(null);
  const [profileName, setProfileName] = useState(null);

  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);
  useEffect(() => {
    if (parameters.updateAllPriceGrids || !parameters.priceGridId) {
      setGridName(intl.formatMessage(messages.All));
      return;
    }
    let mounted = true;
    api.base.get(`${config.appUrls.api}/api/Price/Grid`).then(({ data }) => {
      if (!mounted) return;
      const grids = data.map(x => ({
        ...x,
        name: x.name === 'Default' ? intl.formatMessage(messages.Default) : x.name,
      }));
      const grid = grids.find(x => x.id === parameters.priceGridId);
      setGridName(grid?.name);
    });
    return () => {
      mounted = false;
    };
  }, [parameters, intl]);
  useEffect(() => {
    if (!parameters.priceProfileId) {
      setProfileName(intl.formatMessage(messages.All));
      return;
    }
    let mounted = true;
    api.base.get(`${config.appUrls.api}/api/EmployeeProfile/Get`).then(({ data }) => {
      if (!mounted) return;
      const profile = data.find(x => x.id === parameters.priceProfileId);
      setProfileName(profile?.name);
    });
    return () => {
      mounted = false;
    };
  }, [parameters, intl]);
  if (!parameters) return null;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.PriceGrid} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <div>{gridName}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.PriceProfile} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <div>{profileName}</div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Method} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedListValue list="updateAmountMethod" id={parameters.method} fallback="" />
              </div>
            </div>
            {parameters.method === 0 ? (
              <div className="row">
                <div className="col-md-5 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.Percentage} />
                    </b>
                  </label>
                </div>
                <div className="col-md-7 col-sm-6">
                  <FormattedNumber value={parameters.amountOrPercentage ?? 0} style="percent" />
                </div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-5 col-sm-6">
                  <label>
                    <b>
                      <FormattedMessage {...messages.Amount} />
                    </b>
                  </label>
                </div>
                <div className="col-md-7 col-sm-6">
                  <div>
                    <FormattedNumber
                      value={parameters.amountOrPercentage ?? 0}
                      maximumFractionDigits={2}
                    />
                    <CurrencySymbol />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailPriceGridUpdate.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailPriceGridUpdate);
